import React from 'react';
import ReactDOM from 'react-dom/client';
import SliderGameApp from './SliderGameApp';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SliderGameApp />
  </React.StrictMode>
);